import { AxiosResponse } from 'axios'
import { FormApi } from 'final-form'
import lodash from 'lodash'
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { useParams } from 'react-router'
import { toast } from 'react-toastify'

import FinalForm from '../../../../1stlog-ui/src/components/Form'
import { request } from '../../../../1stlog-ui/src/utils'
import useReturnApp from '../useReturnApp'
import Form from './Form'

const Login = (): React.ReactElement => {
  const { setReceiver } = useReturnApp()
  const { short: shortUrlParam } = useParams()

  const [form, setForm] = useState<FormApi>()
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (values): Promise<object | void> => {
    try {
      const { shortcode, password, showPassword } = values
      setIsLoading(true)
      const { data, status } = (await request({
        method: 'post',
        url: '/return/short',
        data: {
          short: shortcode,
          password: showPassword ? password : undefined,
        },
        validateStatus: (status) => status >= 200 && status <= 499,
      })) as AxiosResponse<any>
      const {
        hasPassword,
        validPasswordEntered,
        short,
        returnReasons = [],
        packagingTypes = [],
      } = data

      if (status === 400) {
        return {
          shortcode: i18n.t(
            'error_shortcode_not_found',
            'Kürzel nicht gefunden',
          ),
        }
      }

      // login ok
      if (!hasPassword || (hasPassword && validPasswordEntered)) {
        setReceiver({ ...short, returnReasons, packagingTypes })
        return
      }

      // password required
      if (hasPassword && !validPasswordEntered) {
        if (showPassword) {
          // return error, password was wrong
          return {
            password: i18n.t('error_invalid_password', 'Ungültiges Passwort'),
          }
        } else {
          // show password field
          form?.change('showPassword', true)
        }
      }
    } catch (err) {
      toast.error(
        'Authentifizierung fehlgeschlagen. Bitte versuchen Sie es später erneut.',
      )
    } finally {
      setIsLoading(false)
    }
  }

  // Set initial shortcode to form
  useEffect(() => {
    if (!form || !form.change) {
      return
    }
    if (shortUrlParam && lodash.size(shortUrlParam) > 1) {
      setTimeout(() => {
        form.change('shortcode', shortUrlParam)
        form.submit()
      }, 0)
    }
  }, [form])

  return (
    <FinalForm onSubmit={onSubmit} setForm={setForm}>
      <Container>
        {form && <Form form={form} isLoading={isLoading} />}
      </Container>
    </FinalForm>
  )
}

export default Login
